import { render, staticRenderFns } from "./import-data-result.vue?vue&type=template&id=564aa0ab&scoped=true&"
import script from "./import-data-result.vue?vue&type=script&lang=js&"
export * from "./import-data-result.vue?vue&type=script&lang=js&"
import style0 from "./import-data-result.vue?vue&type=style&index=0&id=564aa0ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564aa0ab",
  null
  
)

export default component.exports